import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_3 = { class: "q-pa-sm flex flex-center bg-white q-mb-md" }
const _hoisted_4 = { class: "q-pa-sm flex flex-center bg-white q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_social_accounts_btn = _resolveComponent("social-accounts-btn")!
  const _component_app_user = _resolveComponent("app-user")!
  const _component_async_items_loader = _resolveComponent("async-items-loader")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_post = _resolveComponent("post")!
  const _component_posts_grid = _resolveComponent("posts-grid")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_async_items_loader, {
      task: _ctx.task,
      "num-items": _ctx.visiblePosts.length
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_user, null, {
          default: _withCtx(({ isCustomer }) => [
            isCustomer
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "No posts found"))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createTextVNode(" Connect your social media accounts to get started. "),
                  (_ctx.clientId)
                    ? (_openBlock(), _createBlock(_component_social_accounts_btn, {
                        key: 0,
                        "client-id": _ctx.clientId,
                        icon: "fa fa-plus",
                        label: "Connect",
                        color: "primary",
                        class: "on-right"
                      }, null, 8, ["client-id"]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["task", "num-items"]),
    (_ctx.paginationTop)
      ? _renderSlot(_ctx.$slots, "pagination", _normalizeProps(_mergeProps({ key: 0 }, { page: _ctx.page, total: _ctx.total, perPage: _ctx.perPage, numPages: _ctx.numPages, changePage: _ctx.changePage, prev: _ctx.prev, next: _ctx.next, isLoading: _ctx.isLoading })), () => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createVNode(_component_pagination, {
              "model-value": _ctx.page,
              total: _ctx.total,
              "per-page": _ctx.perPage,
              "direction-links": "",
              "boundary-links": "",
              class: "bg-white",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage($event)))
            }, null, 8, ["model-value", "total", "per-page"])
          ], 512), [
            [_vShow, !_ctx.persist && _ctx.total]
          ])
        ])
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ visiblePosts: _ctx.visiblePosts })), () => [
      _createVNode(_component_posts_grid, { posts: _ctx.visiblePosts }, {
        default: _withCtx((post) => [
          _createVNode(_component_post, {
            post: post,
            "show-client": !_ctx.isClientContext,
            notes: "",
            trash: "",
            actions: "",
            scrollable: "",
            popup: "",
            class: "animated fadeIn"
          }, null, 8, ["post", "show-client"])
        ]),
        _: 1
      }, 8, ["posts"])
    ]),
    (_ctx.infiniteScroll && _ctx.page > 1)
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 1,
          task: _ctx.task,
          class: "q-my-md"
        }, null, 8, ["task"]))
      : _createCommentVNode("", true),
    (!_ctx.paginationTop)
      ? _renderSlot(_ctx.$slots, "pagination", _normalizeProps(_mergeProps({ key: 2 }, { page: _ctx.page, total: _ctx.total, perPage: _ctx.perPage, numPages: _ctx.numPages, changePage: _ctx.changePage, prev: _ctx.prev, next: _ctx.next, isLoading: _ctx.isLoading })), () => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createVNode(_component_pagination, {
              "model-value": _ctx.page,
              total: _ctx.total,
              "per-page": _ctx.perPage,
              "direction-links": "",
              "boundary-links": "",
              class: "bg-white",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage($event)))
            }, null, 8, ["model-value", "total", "per-page"])
          ], 512), [
            [_vShow, !_ctx.paginationTop && !_ctx.persist && _ctx.total]
          ])
        ])
      : _createCommentVNode("", true)
  ]))
}